import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import VxeUITable from 'vxe-table'
// Element Plus 中文语言包，确保分页、日期选择器、消息框等内置文本显示中文。
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import 'vxe-table/lib/style.css'
import App from './App.vue'
import router from './router'
import store from './store'
import request from './request/request'
import '@/assets/js/rem.js'

const app = createApp(App)

// 仅保留请求对象的全局挂载；消息提示和事件总线统一通过显式 import 使用，减少隐式全局依赖。
app.config.globalProperties.$request = request
app.use(ElementPlus, { locale: zhCn })
app.use(VxeUITable)
app.use(router)
app.use(store)
app.mount('#app')
